import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ProvinciaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: provinciaInputType) {
          provincia {
            obtenerSegunFiltro(filtro: {exacto: $entidad}) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  region_codigo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.provincia.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
}
ProvinciaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProvinciaService_Factory() { return new ProvinciaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ProvinciaService, providedIn: "root" });
